(() => {
  const key = 'sofly-appearance';
  function appearance(value, notify = false) {
    const preference = ['light','dark','system'].includes(value) ? value : 'system';
    value = preference === 'system' ? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : preference;
    document.documentElement.dataset.soflyPreference = preference;
    document.documentElement.dataset.soflyAppearance = value;
    document.querySelectorAll('[data-sf-theme-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(value === 'dark'));
      button.setAttribute('aria-label', value === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      button.title = button.getAttribute('aria-label');
    });
    if (notify) document.dispatchEvent(new CustomEvent('sofly:appearance-change', {detail: preference}));
  }
  window.SoFlyAppearance = {apply: appearance};
  matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => { if (document.documentElement.dataset.soflyPreference === 'system') appearance('system'); });
  function initialise(scope = document) {
    let saved = document.documentElement.dataset.soflyPreference || 'system';
    try { saved = localStorage.getItem(key) || saved; } catch (_) {}
    appearance(saved);
    scope.querySelectorAll('[data-sf-theme-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const next = document.documentElement.dataset.soflyAppearance === 'dark' ? 'light' : 'dark';
        appearance(next, true);
        try { localStorage.setItem(key, next); } catch (_) {}
      });
    });
    scope.querySelectorAll('[data-sf-campaign]').forEach(campaign => {
      if (campaign.dataset.ready) return;
      campaign.dataset.ready = 'true';
      const play = campaign.querySelector('[data-sf-play]');
      if (!play) return;
      const media = campaign.querySelector('[data-sf-media]');
      const pause = campaign.querySelector('[data-sf-pause]');
      let player;
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const start = async (automatic = false) => {
        if (!player) {
          const template = (!desktop && campaign.querySelector('[data-sf-video="mobile"]')) || campaign.querySelector('[data-sf-video="desktop"]') || campaign.querySelector('[data-sf-external]');
          if (!template) return;
          media.append(template.content.cloneNode(true));
          player = media.querySelector('video, iframe');
          if (!player) return;
          if (player.tagName === 'VIDEO') {
            player.muted = campaign.dataset.mode === 'ambient';
            player.addEventListener('error', () => { player.remove(); player = null; campaign.classList.remove('sf-playing'); play.hidden = false; play.textContent = 'Retry video'; if (pause) pause.hidden = true; });
            player.addEventListener('ended', () => { campaign.classList.remove('sf-playing'); play.hidden = false; });
            player.addEventListener('pause', () => { if (pause) pause.textContent = 'Play video'; });
            player.addEventListener('play', () => { if (pause) pause.textContent = 'Pause video'; });
          }
        }
        if (player.tagName === 'VIDEO') {
          try { await player.play(); campaign.classList.add('sf-playing'); play.hidden = true; if (pause && campaign.dataset.mode === 'ambient') pause.hidden = false; if (!automatic) { player.tabIndex = 0; player.focus(); } }
          catch (_) { if (player) { player.remove(); player = null; } play.hidden = false; }
        } else {
          const url = new URL(player.src);
          url.searchParams.set('autoplay', '1');
          if (campaign.dataset.mode === 'ambient') { url.searchParams.set('mute', '1'); url.searchParams.set('muted', '1'); }
          player.src = url.toString();
          play.hidden = true;
          if (pause) { pause.hidden = false; pause.textContent = 'Stop video'; }
          if (!automatic) player.focus();
        }
      };
      play.addEventListener('click', () => { campaign.dispatchEvent(new CustomEvent('sf:video-play', {bubbles:true})); start(); });
      if (pause) pause.addEventListener('click', () => { if (!player) return; if (player.tagName === 'IFRAME') { player.remove(); player = null; play.hidden = false; pause.hidden = true; return; } if (player.paused) player.play().catch(() => {}); else player.pause(); });
      campaign.sfStop = () => { if (!player) return; if (player.tagName === 'VIDEO') player.pause(); else { player.remove(); player = null; play.hidden = false; if (pause) pause.hidden = true; } };
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) campaign.sfStop();
      }, { threshold: 0.15 });
      observer.observe(campaign);
      const stopMotion = () => { if (reduced.matches) campaign.sfStop(); };
      reduced.addEventListener('change', stopMotion);
      campaign.sfCleanup = () => { observer.disconnect(); reduced.removeEventListener('change', stopMotion); if (player && player.tagName === 'VIDEO') player.pause(); };
      if (campaign.dataset.mode === 'ambient' && !reduced.matches && !navigator.connection?.saveData && !window.Shopify?.designMode) start(true);
    });
    scope.querySelectorAll('[data-sf-slider]').forEach(slider => {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = 'true';
      const track = slider.querySelector('.sf-launch-grid');
      const slides = [...track.children];
      if (!slides.length) return;
      const dots = [...slider.querySelectorAll('[data-sf-slide-to]')];
      dots.forEach((dot, i) => { dot.hidden = i >= slides.length; });
      const status = slider.querySelector('[data-sf-slide-status]');
      const rotation = slider.querySelector('[data-sf-rotation]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(5000, Number(slider.dataset.interval) || 10000);
      let paused = slider.dataset.rotate !== 'true' || motion.matches || !!window.Shopify?.designMode;
      let hovered = false, visible = true, timer;
      const refreshRotation = () => {
        clearInterval(timer);
        if (rotation) { rotation.textContent = paused ? 'Play' : 'Pause'; rotation.setAttribute('aria-label', paused ? 'Start slideshow' : 'Pause slideshow'); rotation.hidden = slides.length < 2; }
        if (status) status.setAttribute('aria-live', paused ? 'polite' : 'off');
        if (!paused && !hovered && visible && !document.hidden && slides.length > 1) timer = setInterval(() => select(active + 1), interval);
      };
      const manualPause = () => { paused = true; refreshRotation(); };
      rotation?.addEventListener('click', () => { paused = !paused; refreshRotation(); });
      slider.addEventListener('mouseenter', () => { hovered = true; refreshRotation(); });
      slider.addEventListener('mouseleave', () => { hovered = false; refreshRotation(); });
      slider.addEventListener('focusin', event => { if (event.target !== rotation) manualPause(); });
      slider.addEventListener('pointerdown', event => { if (!event.target.closest('[data-sf-rotation]')) manualPause(); });
      slider.addEventListener('sf:video-play', manualPause);
      const onVisibility = () => refreshRotation();
      const onMotion = () => { if (motion.matches) manualPause(); };
      document.addEventListener('visibilitychange', onVisibility);
      motion.addEventListener('change', onMotion);
      const visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; refreshRotation(); }, {threshold:.15});
      visibilityObserver.observe(slider);
      slider.sfSliderCleanup = () => { clearInterval(timer); visibilityObserver.disconnect(); document.removeEventListener('visibilitychange', onVisibility); motion.removeEventListener('change', onMotion); };

      let active = 0;
      function select(index, move = true) {
        active = (index + slides.length) % slides.length;
        if (move) track.scrollTo({left: slides[active].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        slides.forEach((slide, i) => { if (i !== active) slide.sfStop?.(); slide.dispatchEvent(new CustomEvent('sf:slide-active', {detail:i === active})); });
        if (status) status.textContent = `${active + 1} / ${slides.length}`;
      }
      slider.querySelector('[data-sf-prev]')?.addEventListener('click', () => select(active - 1));
      slider.querySelector('[data-sf-next]')?.addEventListener('click', () => select(active + 1));
      dots.forEach(dot => dot.addEventListener('click', () => select(Number(dot.dataset.sfSlideTo))));
      track.addEventListener('scroll', () => {
        const i = slides.reduce((best, slide, n) => Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) < Math.abs(slides[best].getBoundingClientRect().left - track.getBoundingClientRect().left) ? n : best, 0);
        if (i !== active) select(i, false);
      }, {passive:true});
      slider.addEventListener('keydown', event => {
        if (event.target.closest('input,textarea,video,iframe')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      const blockSelect = event => { const i = slides.findIndex(slide => slide.contains(event.target)); if(i >= 0) select(i); };
      slider.addEventListener('shopify:block:select', event => { manualPause(); blockSelect(event); });
      select(0, false);
      refreshRotation();
    });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-sf-campaign]').forEach(campaign => campaign.sfCleanup?.()); event.target.querySelectorAll('[data-sf-slider]').forEach(slider => slider.sfSliderCleanup?.()); });
})();
